import { isTenantSessionRecoveryError } from '@/utils/login-session'

interface PermissionStore {
    getters: {
        tenantId: number | null
    }
    dispatch: (action: string) => Promise<any>
}

export const createPermissionGuard = (permissionStore: PermissionStore) => async (
    _: any,
    __: any,
    next: Function
) => {
    if (permissionStore.getters.tenantId) {
        next()
        return
    }

    try {
        await permissionStore.dispatch('login')
    } catch (error) {
        if (isTenantSessionRecoveryError(error)) {
            return
        }
        // 保持原有行为：登录信息请求失败时仍交由接口拦截器处理跳转或提示。
    }

    next()
}
